<app-page-header title="{{title}}" subtitle="" [accent]="true"></app-page-header>

<link rel="stylesheet" [attr.href]="getWordpressStylesheet()">
<div class="wordpress-container container">
    <div class="text-wp"  [innerHtml]="page | safeHtml" ></div>
</div>

<app-footer></app-footer>